import { ReviewStageDataFieldTypeEnum } from '../../schemas';
import { CheckboxesForm } from '../Checkboxes/CheckboxesForm';
import { DropdownForm } from '../Dropdown/DropdownForm';
import { MultipleChoiceForm } from '../MultipleChoice/MultipleChoiceForm';
import { TextFieldForm } from '../TextField/TextFieldForm';

export const DATA_FIELD_TYPE_TO_FORM: Record<
  keyof typeof ReviewStageDataFieldTypeEnum,
  () => JSX.Element | null
> = {
  text_field: TextFieldForm,
  datepicker: () => null,
  radio: MultipleChoiceForm,
  checkboxes: CheckboxesForm,
  dropdown: DropdownForm,
};
